// =====================================================================
// AppIcons.jsx - Icônes vectorielles colorées (style Odoo) pour le
// launcher et la barre latérale. Dessinées à la main (pas une librairie),
// reprises 1:1 du mockup MOCKUP_MENU_ODOO.html.
// Usage: <AppIcon name="cube" size={44} />
// =====================================================================

const ICONS = {
  // Tableau de bord — bento blocks
  dash: (
    <>
      <rect x="2.5" y="2.5" width="8.5" height="8.5" rx="2.2" fill="#F06050" />
      <rect x="13" y="2.5" width="8.5" height="5" rx="2" fill="#6CC1ED" />
      <rect x="13" y="9.5" width="8.5" height="12" rx="2.2" fill="#00A09D" />
      <rect x="2.5" y="13" width="8.5" height="8.5" rx="2.2" fill="#F4A340" />
    </>
  ),
  // Temps & Présence — horloge / camembert
  clock: (
    <>
      <circle cx="12" cy="12" r="9.5" fill="#6CC1ED" />
      <path d="M12 12 L12 2.5 A9.5 9.5 0 0 1 21.5 12 Z" fill="#F06050" />
      <circle cx="12" cy="12" r="2" fill="#fff" />
      <rect x="11.2" y="6.5" width="1.6" height="6" rx="0.8" fill="#fff" />
    </>
  ),
  // Congés — parasol
  leave: (
    <>
      <path d="M2.5 11 A9.5 7 0 0 1 21.5 11 Z" fill="#F4A340" />
      <path d="M12 11 A9.5 7 0 0 1 21.5 11 Z" fill="#F0803C" />
      <path d="M7 11 A5 4 0 0 1 17 11 Z" fill="#FBC56B" />
      <rect x="11.3" y="10.5" width="1.5" height="8.5" rx="0.7" fill="#7a818c" />
      <path d="M8.8 19 a3 2.2 0 0 0 5 0" fill="none" stroke="#7a818c" strokeWidth="1.5" strokeLinecap="round" />
    </>
  ),
  // Trajets — camion
  truck: (
    <>
      <rect x="1.5" y="7" width="12" height="9" rx="1.6" fill="#6CC1ED" />
      <path d="M13.5 9.2 H17 l3.6 3.4 V16 h-7.1 Z" fill="#5B8DEF" />
      <circle cx="6.2" cy="17.2" r="2.2" fill="#37404F" />
      <circle cx="17" cy="17.2" r="2.2" fill="#37404F" />
      <circle cx="6.2" cy="17.2" r="0.8" fill="#cbd5e1" />
      <circle cx="17" cy="17.2" r="0.8" fill="#cbd5e1" />
    </>
  ),
  // Prélèvements — panier
  basket: (
    <>
      <path d="M8 7.5 V6 a4 4 0 0 1 8 0 v1.5" fill="none" stroke="#138D8A" strokeWidth="2" strokeLinecap="round" />
      <path d="M4.2 8 H19.8 l-1.5 9.6 a1.4 1.4 0 0 1 -1.38 1.18 H7.08 a1.4 1.4 0 0 1 -1.38 -1.18 Z" fill="#16A085" />
      <rect x="9" y="11" width="1.6" height="5" rx="0.8" fill="#fff" opacity="0.7" />
      <rect x="13.4" y="11" width="1.6" height="5" rx="0.8" fill="#fff" opacity="0.7" />
    </>
  ),
  // Impressions — imprimante
  print: (
    <>
      <rect x="6.5" y="2.8" width="11" height="6" rx="1" fill="#AEB6C2" />
      <rect x="3" y="8.2" width="18" height="8.4" rx="2.2" fill="#6B7280" />
      <rect x="6.8" y="13" width="10.4" height="7.6" rx="1.2" fill="#EEF1F5" stroke="#AEB6C2" strokeWidth="0.8" />
      <circle cx="17.4" cy="11.2" r="1.1" fill="#00A09D" />
    </>
  ),
  // Inventaire — cube 3D
  cube: (
    <>
      <path d="M12 2.5 L20.5 7 L12 11.5 L3.5 7 Z" fill="#B07CD6" />
      <path d="M3.5 7 L12 11.5 L12 21 L3.5 16.5 Z" fill="#7D3C98" />
      <path d="M20.5 7 L12 11.5 L12 21 L20.5 16.5 Z" fill="#9B59B6" />
    </>
  ),
  // Palettes — palette bois
  pallet: (
    <>
      <rect x="2.5" y="5" width="19" height="3.4" rx="0.6" fill="#B5651D" />
      <rect x="2.5" y="10.3" width="19" height="3.4" rx="0.6" fill="#A0522D" />
      <rect x="2.5" y="15.6" width="19" height="3.4" rx="0.6" fill="#8B4513" />
      <rect x="3.5" y="5" width="2.6" height="14" fill="#6e3a12" opacity="0.55" />
      <rect x="10.7" y="5" width="2.6" height="14" fill="#6e3a12" opacity="0.55" />
      <rect x="17.9" y="5" width="2.6" height="14" fill="#6e3a12" opacity="0.55" />
    </>
  ),
  // Erreurs — triangle alerte (rouge)
  alert: (
    <>
      <path d="M12 2 L22.5 20.5 H1.5 Z" fill="#dc2626" />
      <rect x="11" y="9" width="2" height="6" rx="1" fill="#fff" />
      <circle cx="12" cy="17.5" r="1.3" fill="#fff" />
    </>
  ),
  // Facturation — feuille de facture (€ violet)
  invoice: (
    <>
      <path d="M5 2 H17 L20 5 V22 H5 Z" fill="#7c3aed" />
      <path d="M17 2 V5 H20" fill="none" stroke="#5b21b6" strokeWidth="1" />
      <rect x="8" y="8" width="9" height="1.5" fill="#fff" opacity="0.95" />
      <rect x="8" y="11" width="9" height="1.5" fill="#fff" opacity="0.85" />
      <rect x="8" y="14" width="6" height="1.5" fill="#fff" opacity="0.75" />
      <text x="12.5" y="20" textAnchor="middle" fontSize="6" fontWeight="900" fill="#fff" fontFamily="Arial">€</text>
    </>
  ),
  // Utilisateurs — personnes
  users: (
    <>
      <circle cx="16" cy="9" r="3" fill="#B07CD6" />
      <path d="M11 20 a5 5 0 0 1 10 0 Z" fill="#B07CD6" />
      <circle cx="9" cy="8" r="3.6" fill="#5B8DEF" />
      <path d="M2.5 20 a6.5 6.5 0 0 1 13 0 Z" fill="#5B8DEF" />
    </>
  ),
  // Projets — check
  check: (
    <>
      <circle cx="12" cy="12" r="9.5" fill="#9B59B6" />
      <path d="M7.5 12.2 l3 3 l6-6.4" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  // Verrouillage — cadenas
  lock: (
    <>
      <path d="M7.8 10.5 V7.6 a4.2 4.2 0 0 1 8.4 0 V10.5" fill="none" stroke="#E08A1E" strokeWidth="2.3" strokeLinecap="round" />
      <rect x="4.8" y="10.2" width="14.4" height="10" rx="2.4" fill="#F4A340" />
      <circle cx="12" cy="14.4" r="1.5" fill="#fff" />
      <rect x="11.3" y="14.4" width="1.4" height="3" rx="0.7" fill="#fff" />
    </>
  ),
  // Permissions — bouclier
  shield: (
    <>
      <path d="M12 2.4 l8 3 V12 c0 4.7-3.4 7.9-8 9.5 -4.6-1.6-8-4.8-8-9.5 V5.4 Z" fill="#3498DB" />
      <path d="M8.2 12 l2.4 2.4 4.8-5" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  // Justificatifs médicaux — croix
  med: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="4.6" fill="#00A09D" />
      <rect x="10.6" y="7" width="2.8" height="10" rx="1" fill="#fff" />
      <rect x="7" y="10.6" width="10" height="2.8" rx="1" fill="#fff" />
    </>
  ),
  // Cahier de charge — clipboard avec lignes
  cahier: (
    <>
      <rect x="5" y="4" width="14" height="17" rx="2.2" fill="#5B8DEF" />
      <rect x="9" y="2.3" width="6" height="4" rx="1.2" fill="#3B82F6" />
      <rect x="8" y="9.5" width="8" height="1.2" rx="0.6" fill="#fff" />
      <rect x="8" y="12" width="8" height="1.2" rx="0.6" fill="#fff" />
      <rect x="8" y="14.5" width="5.5" height="1.2" rx="0.6" fill="#fff" />
      <rect x="8" y="17" width="7" height="1.2" rx="0.6" fill="#fff" />
    </>
  ),
  // Convoyeur — bande de tri + colis (M-008)
  conveyor: (
    <>
      {/* colis */}
      <rect x="7.5" y="4.5" width="9" height="8.5" rx="1.2" fill="#F4A340" />
      <path d="M7.5 7.5 H16.5" stroke="#d98324" strokeWidth="1.1" />
      <rect x="11.4" y="4.5" width="1.2" height="8.5" fill="#d98324" />
      {/* bande */}
      <rect x="1.8" y="14.6" width="20.4" height="3.2" rx="1.6" fill="#6B7280" />
      {/* rouleaux */}
      <circle cx="4.3" cy="19.4" r="1.7" fill="#37404F" />
      <circle cx="9.4" cy="19.4" r="1.7" fill="#37404F" />
      <circle cx="14.6" cy="19.4" r="1.7" fill="#37404F" />
      <circle cx="19.7" cy="19.4" r="1.7" fill="#37404F" />
      <circle cx="4.3" cy="19.4" r="0.6" fill="#cbd5e1" />
      <circle cx="9.4" cy="19.4" r="0.6" fill="#cbd5e1" />
      <circle cx="14.6" cy="19.4" r="0.6" fill="#cbd5e1" />
      <circle cx="19.7" cy="19.4" r="0.6" fill="#cbd5e1" />
    </>
  ),
  // Remise transporteur — bordereau signé
  slip: (
    <>
      <rect x="4" y="2.5" width="16" height="19" rx="2" fill="#0E9594" />
      <rect x="7" y="6.5" width="10" height="1.4" rx="0.7" fill="#fff" opacity="0.95" />
      <rect x="7" y="9.6" width="10" height="1.4" rx="0.7" fill="#fff" opacity="0.8" />
      <rect x="7" y="12.7" width="6.5" height="1.4" rx="0.7" fill="#fff" opacity="0.65" />
      <path d="M6.8 18.2 c1.6-2.4 2.6 1.8 4.2 -0.4 c1.3-1.8 2.1 1.5 3.4 0.1 c0.7-0.8 1.3-0.6 2.1 0.1" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
    </>
  ),
  // Dimensions colis — colis coté
  ruler: (
    <>
      <rect x="5" y="3.5" width="14" height="11" rx="1.4" fill="#8BC34A" />
      <path d="M5 7.2 H19" stroke="#5E9623" strokeWidth="1.2" />
      <rect x="11.1" y="3.5" width="1.8" height="11" fill="#5E9623" opacity="0.55" />
      <path d="M3.6 18.6 H20.4" stroke="#37404F" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M5.6 16.9 L3.3 18.6 L5.6 20.3" fill="none" stroke="#37404F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.4 16.9 L20.7 18.6 L18.4 20.3" fill="none" stroke="#37404F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  // Accidents & premiers soins — trousse de secours
  firstaid: (
    <>
      <path d="M9 6.6 V5.4 a1.6 1.6 0 0 1 1.6-1.6 h2.8 a1.6 1.6 0 0 1 1.6 1.6 V6.6" fill="none" stroke="#9F1239" strokeWidth="2" strokeLinecap="round" />
      <rect x="2.4" y="6.4" width="19.2" height="13.2" rx="2.6" fill="#E11D48" />
      <rect x="2.4" y="11.4" width="19.2" height="1.6" fill="#9F1239" opacity="0.35" />
      <rect x="10.7" y="9.2" width="2.6" height="8" rx="1" fill="#fff" />
      <rect x="8" y="11.9" width="8" height="2.6" rx="1" fill="#fff" />
    </>
  ),
  // Droits d'accès — clé
  key: (
    <>
      <circle cx="8.2" cy="11.8" r="5.4" fill="none" stroke="#4F46E5" strokeWidth="3" />
      <circle cx="8.2" cy="11.8" r="1.7" fill="#fff" />
      <rect x="12.6" y="10.4" width="8.6" height="2.8" rx="1.2" fill="#4F46E5" />
      <rect x="16.4" y="13.2" width="2.4" height="3.4" rx="1" fill="#4F46E5" />
      <rect x="19.8" y="13.2" width="2.4" height="2.4" rx="1" fill="#6366F1" />
    </>
  ),
  // Présence — personne pointée
  presence: (
    <>
      <circle cx="9.6" cy="7.2" r="3.9" fill="#16A34A" />
      <path d="M2.6 19.8 a7 7 0 0 1 14 0 Z" fill="#16A34A" />
      <circle cx="17.6" cy="17.2" r="5.1" fill="#15803D" />
      <path d="M15.3 17.3 l1.7 1.7 l3.1-3.4" fill="none" stroke="#fff" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  // Heures supplémentaires — horloge avec un plus
  overtime: (
    <>
      <circle cx="10.6" cy="10.6" r="8.3" fill="#9333EA" />
      <circle cx="10.6" cy="10.6" r="1.5" fill="#fff" />
      <rect x="9.9" y="5.4" width="1.5" height="5.6" rx="0.75" fill="#fff" />
      <rect x="10.6" y="9.9" width="4.6" height="1.5" rx="0.75" fill="#fff" />
      <circle cx="18.2" cy="17.8" r="5.2" fill="#6B21A8" />
      <rect x="17.4" y="14.6" width="1.7" height="6.4" rx="0.85" fill="#fff" />
      <rect x="15" y="17" width="6.4" height="1.7" rx="0.85" fill="#fff" />
    </>
  ),
  // Applications — pinwheel 4 couleurs (entrée launcher)
  apps: (
    <>
      <path d="M12 3 A9 9 0 0 1 21 12 L12 12 Z" fill="#F06050" />
      <path d="M21 12 A9 9 0 0 1 12 21 L12 12 Z" fill="#00A09D" />
      <path d="M12 21 A9 9 0 0 1 3 12 L12 12 Z" fill="#6CC1ED" />
      <path d="M3 12 A9 9 0 0 1 12 3 L12 12 Z" fill="#F4A340" />
      <circle cx="12" cy="12" r="2.4" fill="#fff" />
    </>
  ),
};

export function AppIcon({ name, size = 44, style }) {
  const glyph = ICONS[name];
  if (!glyph) return null;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" style={style} aria-hidden="true">
      {glyph}
    </svg>
  );
}

export const APP_ICON_NAMES = Object.keys(ICONS);
export default AppIcon;
